import SideNav from "./SideNav";
import TopBar from "./TopBar";
import React, { useState,  useEffect, useRef, useContext } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import 'datatables.net-dt/css/jquery.dataTables.css';
import $ from 'jquery';
import 'datatables.net';
import {Link, useParams, useNavigate} from "react-router-dom";
import axios from 'axios';
import ReactPaginate from 'react-paginate';
import Swal from 'sweetalert2';
import moment from 'moment';
import UserContext from './UserContext';


function Bookings(){
    const API_URL = process.env.REACT_APP_API_URL;
    const navigate = useNavigate();
const tableRef = useRef();
    const [isLoading, setIsLoading] = useState(false);
    const [customer, setCustomer] = useState([]);
    const [payments, setPayments] = useState([]);
    const [searchQuery, setSearchQuery] = useState("");
    const [currentPage, setCurrentPage] = useState(0);
    const [perPage, setPerPage] = useState(25);
    const [error_list, setErrorList] = useState([]);
    const userContext = useContext(UserContext);
    const [email_template, setEmail_template] = useState([]);
   
    const [dateFrom, setDateFrom] = useState(""); // Start date
    const [dateTo, setDateTo] = useState(""); 
    const [filteredLocations, setFilteredLocations] = useState([]);
    const [selectedGameLocation, setSelectedGameLocation] = useState('');
    const [showDateFields, setShowDateFields] = useState(false);  
    const [selectedStatus, setSelectedStatus] = useState('Completed'); 
    const [game_available, setGame_available] = useState([]);
    const [selectedGame, setSelectedGame] = useState('');
    const [team, setTeam] = useState([]);    
    const API_BASE_URL = process.env.REACT_APP_BASE_URL;
    const [selectedStaff, setSelectedStaff] = useState(''); 
const [sortColumn, setSortColumn] = useState(null);
const [sortDirection, setSortDirection] = useState('asc'); // or 'desc'

  
      const filteredResult = customer.filter((item) => {
   const matchesSearchQuery = `${item.firstname} ${item.lastname}`.toLowerCase().includes(searchQuery.toLowerCase()) ||
  item.booking_ref_id.toLowerCase().includes(searchQuery.toLowerCase()) ||
  item.phone.toLowerCase().includes(searchQuery.toLowerCase()) ||
  item.email.toLowerCase().includes(searchQuery.toLowerCase()) ||
  item.location_name.toLowerCase().includes(searchQuery.toLowerCase());



        const matchesLocation = selectedGameLocation === "all" || item.location_id === parseInt(selectedGameLocation);
       const matchesGame = selectedGame === "all" || item.game_id === parseInt(selectedGame);
        const matchesStaff = selectedStaff === "all" || 
  (item.staff && item.staff.split(",").map((id) => id.trim()).includes(String(selectedStaff)));

   
       // Check if booking date is within the selected date range
const matchesDate = (!dateFrom || item.booked_date >= dateFrom) &&
(!dateTo || item.booked_date <= dateTo);
//const matchesStatus = selectedStatus === "all" || item.status === selectedStatus;

return matchesSearchQuery && matchesLocation && matchesGame && matchesStaff && matchesDate;
 //&& matchesStatus;

       });

const sortedResult = [...filteredResult].sort((a, b) => {
  if (!sortColumn) return 0;

  const aValue = a[sortColumn] ?? '';
  const bValue = b[sortColumn] ?? '';

  if (typeof aValue === 'number' && typeof bValue === 'number') {
    return sortDirection === 'asc' ? aValue - bValue : bValue - aValue;
  }

  return sortDirection === 'asc'
    ? String(aValue).localeCompare(String(bValue))
    : String(bValue).localeCompare(String(aValue));
});

     
const handleSort = (columnKey) => {
  if (sortColumn === columnKey) {
    setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc');
  } else {
    setSortColumn(columnKey);
    setSortDirection('asc');
  }
};




      const handlePageChange = (selectedPage) => {
        setCurrentPage(selectedPage.selected);
      };    
      
      useEffect(() => {
        if (userContext.username) {
          setIsLoading(true);
          AOS.init({ duration: 1200 });
            getLocationByUser();
        }
      }, [userContext.username]); 
      


async function getLocationByUser() {

  axios.get(`${API_URL}/view-team-member-by-username/${userContext.username}`).then(res => {
   if(res.data.status === 200){

    const filteredLocations = res.data.locations;

    setFilteredLocations(filteredLocations);  
    if (filteredLocations.length > 0) {
     const defaultLocation = filteredLocations[0].id;
     setSelectedGameLocation('all');
     fetchGameAvailable(defaultLocation); 
    }

       
    setSelectedStaff('all');

    const customer = res.data.bookings;
    setCustomer(customer);
    setPayments(res.data.payments.filter(payment => payment.is_deleted === 0));
// console.log(res.data.bookings)
   }
   else if(res.data.status === 404){
       //setMessage(res.data.message);
       //console.log(res.data.status);
       }
       
   setIsLoading(false);
});
       
   
}


useEffect(() => {
  getTeamList();
  getEmailTemplateList();
}, []);

function getTeamList()
  {    
   
  axios.get(`${API_URL}/view-team-members`).then(res=>{
        if(res.data.status === 200){
            setTeam(res.data.team);    
        }     
        else if(res.data.status === 404){
          setTeam([]);
           // setMessage(res.data.message);     
            }             
     });    
  }

   function getEmailTemplateList()
      {    
        axios.get(`${API_URL}/view-email-template`).then(res=>{
            if(res.data.status === 200){
                setEmail_template(res.data.emailTemplate);       
            }     
            else if(res.data.status === 404){
              setEmail_template([]);
               // setMessage(res.data.message);     
                }             
         });    
      }

const handleGameAvailableLocationChange = (e) => {
  const selectedGameLocationId = e.target.value;
  setSelectedGameLocation(selectedGameLocationId);
 
  if(selectedGameLocationId == "all")
  {
      const locationIds = filteredLocations.map(location => location.id);
      fetchAllLocationGameAvailable(locationIds);
  }
  else{
      fetchGameAvailable(selectedGameLocationId);
  }
};


const handleStaffChange = (e) => {
  const selectedStaffId = e.target.value;
  setSelectedStaff(selectedStaffId);
}


async  function fetchGameAvailable(locationId) {
        // setIsLoading(true); // Start loader for game fetching
         axios.get(`${API_URL}/view-available-game-by-locationId/${locationId}`)
             .then(res => {
                 if (res.data.games) {
                     setGame_available(res.data.games);
                     if (res.data.games.length > 0) {
                         setSelectedGame(res.data.games[0].id);
                     } else {
                         setSelectedGame('');
                     }
                 } else {
                     setGame_available([]);
                 }
             })
             .catch(error => {
                 console.error("Error fetching games:", error);
             })
             .finally(() => {
                setIsLoading(false); // Now that both data (location and games) have loaded, stop main loader
              });
     }




function fetchAllLocationGameAvailable(locationIds) {
  // setIsLoading(true); // Start loader for game fetching
  const locationIdsString = locationIds.join(','); // Convert array to comma-separated string

  axios.get(`${API_URL}/view-available-game-by-locationIds/${locationIdsString}`)
      .then(res => {
          if (res.data.games) {
              setGame_available(res.data.games);
              if (res.data.games.length > 0) {
                  setSelectedGame(res.data.games[0].id);
              } else {
                  setSelectedGame('');
              }
          } else {
              setGame_available([]);
          }
          // setIsLoading(false); // Stop loader for game fetching
      })
      .catch(error => {
          console.error("Error fetching games:", error);
          // setIsLoading(false); // Stop loader for game fetching
      });
}

  async function getCustomerList(){
 
    axios.get(`${API_URL}/view-booked-slots`).then(res => {
        if(res.data.status === 200){
          const customer = res.data.bookedSlots;
            setCustomer(res.data.bookedSlots);
        // console.log(res.data.bookedSlots);
        }
        else if(res.data.status === 404){
            //setMessage(res.data.message);
            //console.log(res.data.status);
            }
            
        setIsLoading(false);
     });
       
    }

    const formatBookedTime = (bookedTime) => {
        try {
          const timeSlots = JSON.parse(bookedTime); // Assuming bookedTime is a JSON string
          if (Array.isArray(timeSlots) && timeSlots.length > 0) {
            
            // Sort time slots by start time before merging
            const sortedSlots = timeSlots.sort((a, b) => {
              const [startA] = a.split(' - ');
              const [startB] = b.split(' - ');
              return moment(startA, 'hh:mm A').diff(moment(startB, 'hh:mm A'));
            });
      
            let mergedSlots = [];
            let currentRangeStart = null;
            let currentRangeEnd = null;
      
            sortedSlots.forEach((slot, index) => {
              const [startTime, endTime] = slot.split(' - ');
              const currentStartTime = moment(startTime, 'hh:mm A');
              const currentEndTime = moment(endTime, 'hh:mm A');
      
              if (!currentRangeStart) {
                // First time slot, initialize the range
                currentRangeStart = currentStartTime;
                currentRangeEnd = currentEndTime;
              } else if (currentRangeEnd.isSame(currentStartTime)) {
                // If the current slot starts when the last one ended, extend the range
                currentRangeEnd = currentEndTime;
              } else {
                // If the current slot does not continue from the last one, close the current range and start a new one
                mergedSlots.push(`${currentRangeStart.format('h:mm A')} - ${currentRangeEnd.format('h:mm A')}`);
                currentRangeStart = currentStartTime;
                currentRangeEnd = currentEndTime;
              }
      
              // If it's the last slot, push the current range
              if (index === sortedSlots.length - 1) {
                mergedSlots.push(`${currentRangeStart.format('h:mm A')} - ${currentRangeEnd.format('h:mm A')}`);
              }
            });
      
            return mergedSlots.join(', '); // Join the merged slots with a comma
          }
          return 'No time slots available';
        } catch (error) {
          console.error("Error parsing booked time:", error);
          return 'Invalid time format';
        }
      };

      function convertPlainTextToHTML(text) {
        return text
            .replace(/\n/g, '<br>')  // Replace line breaks with <br>
            .replace(/ {2,}/g, match => '&nbsp;'.repeat(match.length));  // Replace multiple spaces with &nbsp;
    }
    
    const handleViewBookings = (bookingId) => {
    
      navigate('/booking-details/'+bookingId);      
    };

    const cancelBooking = (e, id) => {
      e.preventDefault();
      
      var buttonClicked = window.confirm("Are you sure you want to cancel booking?");
      
      if (buttonClicked === true) {

        const cancelReason = window.prompt("Enter the reason for cancellation (optional):");

        var sendNotification = window.confirm("Do you want to send a cancellation notification email?");
          
        
        // Make a PUT request to update booking_completed to 0
      

         axios.put(`${API_URL}/cancel-booked-slot/` + id, {
              booking_completed: 0 ,
              updated_by: userContext.userDetails.id,
              booked_date: customer[0].booked_date,       // Add booked_date if needed
              booked_time: customer[0].booked_time,       // Add booked_time if needed
              no_of_adults: customer[0].no_of_adults,              // Add no_of_adults
              no_of_children: customer[0].no_of_children,
              cancel_reason: cancelReason || null,   
        
          }).then(res => {
            if (sendNotification === true) {
            const data = customer.find(item=>item.id === id)
            const emailData =  prepareEmailData(data, cancelReason);
            // API call to send email
            const emailResponse =  axios.post(`${API_URL}/send-email`, emailData);
            }
             
              Swal.fire({
                  icon: "success",
                  text: res.data.message
              }).then(function() {
                setIsLoading(true);
                  // Optionally update UI after booking is cancelled
                  getLocationByUser(); 
              });
          
          }).catch(error => {
              // Handle any errors here
            //   Swal.fire({
            //   text:error.response.data.message,
            //   icon:"error"
            // })
            setIsLoading(false);
              console.error("Error canceling booking:", error);
          });
      } else {
        setIsLoading(false);
          getLocationByUser();
      }
  }
   function prepareEmailData(bookingDetails, cancelReason) {

    const CancelTemplate = email_template.find(item => item.template_name === 'Booking Cancellation');
 

    const formattedBookedTime = formatBookedTime(bookingDetails.booked_time);
    // Convert the plain text template to HTML
    const message = convertPlainTextToHTML(CancelTemplate.message)
        .replace('[customer_name]', `${bookingDetails.firstname} ${bookingDetails.lastname}`)
        .replace('[event_date]', moment(bookingDetails.booked_date).format('D MMMM YYYY'))
        .replace('[event_time]', formattedBookedTime)  // Joining the times array into a string
        .replace('[location]', bookingDetails.location_name)
        .replace('[number_of_players]', bookingDetails.total_players)
        .replace('[cancel_reason]', cancelReason)
        .replace('[package_name]',
          bookingDetails.game_type_name ||
          (bookingDetails.package_name === 'Corporate' 
            ? `${bookingDetails.package_name} - ${bookingDetails.corporate_package_name}`
            : `${bookingDetails.package_name} - ${bookingDetails.game_package_name}`
          ))
          //bookingDetails.game_type_name || `${bookingDetails.package_name} - ${bookingDetails.game_package_name}`)
      
    return {
        booking_id: bookingDetails.booking_id,
        to: bookingDetails.email,
        subject: CancelTemplate.subject,
        message // This is now HTML formatted
    };
}


const handleDateFromChange = (e) => {
  setDateFrom(e.target.value);
};

const handleDateToChange = (e) => {
  setDateTo(e.target.value);
};


const formatDateLocal = (date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};


const handleDateOptionChange = (event) => {
  const value = event.target.value;
  //const today = new Date();
  const todayString = new Date().toLocaleDateString('en-CA', {
  timeZone: 'America/Toronto',
});
const [year, month, day] = todayString.split('-');
const today = new Date(year, month - 1, day); // Now it's a real Date object

  switch (value) {
    case "today":
      setDateFrom(formatDateLocal(today));
      setDateTo(formatDateLocal(today));
      setShowDateFields(false);
      break;

    case "yesterday":
      const yesterday = new Date(today);
      yesterday.setDate(today.getDate() - 1);
      setDateFrom(formatDateLocal(yesterday));
      setDateTo(formatDateLocal(yesterday));
      setShowDateFields(false);
      break;

    case "this_week":
      const startOfWeek = new Date(today);
      startOfWeek.setDate(today.getDate() - today.getDay()); // Sunday
      const endOfWeek = new Date(startOfWeek);
      endOfWeek.setDate(startOfWeek.getDate() + 6); // Saturday
      setDateFrom(formatDateLocal(startOfWeek));
      setDateTo(formatDateLocal(endOfWeek));
      setShowDateFields(false);
      break;

    case "last_week":
      const lastWeekStart = new Date(today);
      lastWeekStart.setDate(today.getDate() - today.getDay() - 7); // Last week's Sunday
      const lastWeekEnd = new Date(lastWeekStart);
      lastWeekEnd.setDate(lastWeekStart.getDate() + 6); // Last week's Saturday
      setDateFrom(formatDateLocal(lastWeekStart));
      setDateTo(formatDateLocal(lastWeekEnd));
      setShowDateFields(false);
      break;

    case "this_month":
      const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
      const lastDayOfMonth = new Date(today.getFullYear(), today.getMonth() + 1, 0);
      setDateFrom(formatDateLocal(firstDayOfMonth));
      setDateTo(formatDateLocal(lastDayOfMonth));
      setShowDateFields(false);
      break;

    case "last_month":
      const lastMonth = new Date(today);
      lastMonth.setMonth(today.getMonth() - 1);
      const firstDayOfLastMonth = new Date(lastMonth.getFullYear(), lastMonth.getMonth(), 1);
      const lastDayOfLastMonth = new Date(lastMonth.getFullYear(), lastMonth.getMonth() + 1, 0);
      setDateFrom(formatDateLocal(firstDayOfLastMonth));
      setDateTo(formatDateLocal(lastDayOfLastMonth));
      setShowDateFields(false);
      break;

    case "this_year":
      const firstDayOfYear = new Date(today.getFullYear(), 0, 1);
      const lastDayOfYear = new Date(today.getFullYear(), 11, 31);
      setDateFrom(formatDateLocal(firstDayOfYear));
      setDateTo(formatDateLocal(lastDayOfYear));
      setShowDateFields(false);
      break;

    case "last_year":
      const lastYear = today.getFullYear() - 1;
      const firstDayOfLastYear = new Date(lastYear, 0, 1);
      const lastDayOfLastYear = new Date(lastYear, 11, 31);
      setDateFrom(formatDateLocal(firstDayOfLastYear));
      setDateTo(formatDateLocal(lastDayOfLastYear));
      setShowDateFields(false);
      break;

    case "custom":
      setShowDateFields(true);
      setDateFrom('');
      setDateTo('');
      break;

    default:
      setDateFrom('');
      setDateTo('');
      setShowDateFields(false);
  }
};


const renderSortIcon = (column) => {
  if (sortColumn === column) {
    return sortDirection === "asc" ? (
      <i className="bi bi-sort-up ms-1" style={{ color: '#0d6efd' }}></i> 
    ) : (
      <i className="bi bi-sort-down ms-1" style={{ color: '#0d6efd' }}></i> 
    );
  }

  return (
    <i className="bi bi-arrow-down-up ms-1" style={{ color: '#adb5bd' }}></i> 
  );
};






const handleStatusChange = (e) => {
  setSelectedStatus(e.target.value);
};

// const  triggerEmail=() =>{
//   axios.post(`${API_URL}/trigger-email-pending`, {
//     booking_id: 2
//   }, {
//     headers: {
//       'Content-Type': 'application/json',
//       'Accept': 'application/json'
//     }
//   })
//   .then(response => {
//     console.log(response.data);
//     alert(response.data.message);
//   })
//   .catch(error => {
//     console.error('Error:', error);
//     alert('Error occurred!');
//   });
// }

// const  triggerEmail=() =>{
//   axios.post(`${API_URL}/trigger-email-bambora`, {
//     id: 3
//   }, {
//     headers: {
//       'Content-Type': 'application/json',
//       'Accept': 'application/json'
//     }
//   })
//   .then(response => {
//    // console.log(response.data);
//     alert(response.data.message);
//   })
//   .catch(error => {
//     console.error('Error:', error);
//     alert('Error occurred!');
//   });
// }
// const handleGenerateQRCode = async () => {
//   try {
//     const bookingRefId = 'LC0400033';
//     const originalUrl = `${API_BASE_URL}/consent-form-page/${bookingRefId}`;

//     // Base64 encode the URL
//     const encodedUrl = btoa(originalUrl);

  

//     const response = await axios.get(`${API_URL}/generate-qr-code`, {
//       params: {
//         url: originalUrl,
//         ref_id: bookingRefId
//       }
//     });
//     // If needed, display the QR code image
//     // setQrCodeUrl(response.data); // or response.data.qrCodeUrl if you're returning a JSON

//     console.log('QR code URL:', response.data);
//   } catch (err) {
//     console.error('Error generating QR code:', err);
//   }
// };




    return(
        <div>
<SideNav/>
      <TopBar/>

      {isLoading?
     <div className="loader-container" style ={{backgroundColor: "rgba(0, 0, 0, 0.5)", position: "fixed",top: "0",left: "0",width: "100%",height: "100%",display: "flex",justifyContent: "center",alignItems: "center",zIndex: "9999"}}>
    <div class="d-flex justify-content-center">
  <div class="spinner-border" role="status">
  </div>
  </div>
</div>:null}
      <div class="right_panel position contact_section vh-100" id="right_panel">

        <div class="main_title" data-aos="fade-down" data-aos-delay="" data-aos-duration="1200">
            <h1><i class="bi bi-book"></i> Bookings</h1>
           
                {/* <button class="btn btn-sm btn_secondary">
                <Link style={{color:"white"}} to={'/create-customer'}>Create New Customer </Link>
                  </button> */}
          
        </div>



        <div class="content_wrapper pt-0" data-aos-delay="" data-aos-duration="1200">
        <div class="vm_content_box_1">
        <div class="content pt-1">
                <div class=" pt-1 pb-1">
                <div class="row ">

              
                <div class="content col-md-2">
                                <div class="form-group pt-2 pb-2">
                                    <label>Location</label>
                                    <select class="form-select" id="selectedGameLocation" name="selectedGameLocation" value={selectedGameLocation} onChange={handleGameAvailableLocationChange}>
                                        <option value="">Select game location</option>
                                        <option value="all">All</option>
                                        {filteredLocations.map((location) => (
                                            <option key={location.id} value={location.id}>
                                                {location.location_name}
                                            </option>
                                        ))}
                                    </select>   {!selectedGameLocation && (
                                        <span class="text-danger">{error_list.location_id}</span>)}
                                </div>
                            </div>


                             <div class="content col-md-2">
                                <div class="form-group pt-2 pb-2">
                                <label>Staff Members</label>
                                    <select class="form-select" id="selectedStaff" name="selectedStaff" value={selectedStaff} onChange={handleStaffChange}>
                                        <option value="">Select Staff members</option>
                                        <option value="all">All</option>
                                        {team
                                        .filter(
                                          (staff) =>
                                            staff.user_role === "Coordinator" &&
                                            staff.location_id?.split(',').some(id =>
                                              filteredLocations.some(loc => loc.id === parseInt(id))
                                            )
                                        )
                                        
                                         .map((staff, idx) => (
                                            <option key={idx} value={staff.id}>{staff.first_name} {staff.last_name}</option>
                                        ))}
                                    </select>   {!selectedStaff && (
                                        <span class="text-danger">{error_list.staff}</span>)}
                                </div>
                            </div>

    {/* <div class="content col-md-2">
                                <div class="form-group pt-2 pb-2">
                                  
                                    <label>Status</label>
        <select class="form-select" id="status" name="status" value={selectedStatus} onChange={handleStatusChange}>
             <option value="all">All</option>
            <option value="Completed">Completed</option>
            <option value="Incomplete">Incomplete</option>
            <option value="Cancelled">Cancelled</option>
        </select>
                                  
                                </div>
                            </div> */}


                            <div className="content col-md-2">
                <div className="form-group pt-2 pb-2">
                    <label>Date Options</label>
                    <select className="form-select" id="dateOptions" onChange={handleDateOptionChange}>
                        <option value="">Select date filter</option>
                        <option value="today">Today</option>
                        <option value="yesterday">Yesterday</option>
                        <option value="this_week">This Week</option>
                        <option value="last_week">Last Week</option>
                        <option value="this_month">This Month</option>
                        <option value="last_month">Last Month</option>
                        <option value="this_year">This Year</option>
                        <option value="last_year">Last Year</option>
                        <option value="custom">Custom</option>
                    </select>
                </div>
            </div>         

            {showDateFields && (
                <>
                            <div class="content col-md-2">
    <div class="form-group pt-2 pb-2">
        <label>Date From</label>
        <input
            type="date"
            className="form-control"
            id="dateFrom"
            name="dateFrom"
            value={dateFrom}
            onChange={handleDateFromChange}
        />
    </div>
</div>

<div class="content col-md-2">
    <div class="form-group pt-2 pb-2">
        <label>Date To</label>
        <input
            type="date"
            className="form-control"
            id="dateTo"
            name="dateTo"
            value={dateTo}
            onChange={handleDateToChange}
        />
    </div>
</div>
</>
            )}
              

                    </div>

                    {/* <button onClick={handleGenerateQRCode }>Trigger Email</button> */}
                    {/* <button onClick={triggerEmail }>Trigger Email</button> */}

                    </div>
                    </div>
                    </div>
                    </div>

        <div class="content_wrapper pt-0" data-aos="fade-down" data-aos-delay="" data-aos-duration="1200">
            
            <div>
                <div class="vm_content_box_1">
                    <div class="content">

                    <div class="row pt-3">
                          
                          <div class="col-md-9 form-group" >
                                  <div class="d-flex input_wrapper">
                                  <div><label>Show   <select name="example_length" aria-controls="example" value={perPage} onChange={(e) => {setCurrentPage(0);setPerPage(Number(e.target.value))}}>
                                      <option value="10">10</option><option value="25">25</option><option value="50">50</option><option value="100">100</option>
                                    </select>  entries</label>
                                    </div>
                                  </div>
                              </div>
  
                              <div class="col-md-3 form-group">
                                  <div class="d-flex input_wrapper">
                                      <div class="icon_wrapper">
                                          <i class="bi bi-search icon"></i>
                                      </div>
                                      <input class="form-control" name="searchQuery" id="searchQuery" placeholder="Search..." type="text" 
                                      value={searchQuery} onChange={(e) => {setSearchQuery(e.target.value)}}/>
                                  </div>
                              </div>
                          </div>
                          <div class="table-responsive">
                        <table ref={tableRef} id="bookingTable" className="display inventory_table_list dataTable dtr-inline" style={{width:"100%"}}>
                            <thead>
                                <tr>
                <th onClick={() => handleSort('booking_ref_id')}>
  Booking Id {renderSortIcon("booking_ref_id")}
</th>

<th onClick={() => handleSort("firstname")}>
  Customer Name {renderSortIcon("firstname")}
</th>

<th onClick={() => handleSort("booked_date")}>
  Booked Date {renderSortIcon("booked_date")}
</th>

<th onClick={() => handleSort("booked_time")}>
  Booked Time {renderSortIcon("booked_time")}
</th>

<th onClick={() => handleSort("game_package_name")}>
  Game Package {renderSortIcon("game_package_name")}
</th>

<th onClick={() => handleSort("no_of_adults")}>
  Adults {renderSortIcon("no_of_adults")}
</th>

<th onClick={() => handleSort("no_of_children")}>
  Kids {renderSortIcon("no_of_children")}
</th>

<th onClick={() => handleSort("grand_total")}>
  Total Amt {renderSortIcon("grand_total")}
</th>

<th onClick={() => handleSort("paid_amount")}>
  Paid Amt {renderSortIcon("paid_amount")}
</th>

<th onClick={() => handleSort("due_amount")}>
  Due Amt {renderSortIcon("due_amount")}
</th>

<th onClick={() => handleSort("location_name")}>
  Location {renderSortIcon("location_name")}
</th>

<th onClick={() => handleSort("staff_names")}>
  Staff {renderSortIcon("staff_names")}
</th>

<th onClick={() => handleSort("first_name")}>
  Booked By {renderSortIcon("first_name")}
</th>

<th onClick={() => handleSort("created_at")}>
  Booked On {renderSortIcon("created_at")}
</th>



                                    <th class="text-end">Action</th>
                                </tr>
                            </thead>
                            <tbody>
                            {sortedResult.length === 0 ? (
       <td colSpan="15" style={{ textAlign: "center", verticalAlign: "middle" }}>
  <p className="odd" style={{ margin: 0 }}>No records found</p>
</td>

      ) : (
                            sortedResult.slice((currentPage * perPage), ((currentPage * perPage) + perPage)).map((item, index) => {
                                           
                              const totalPaid = payments
                              .filter(pay => pay.booking_id === item.id)   // Filter payments for this booking
                              .reduce((sum, pay) => sum + Number(pay.payment_amount), 0); // Sum amounts
                             
                              const formattedTotalPaid = totalPaid.toFixed(2); // Format total paid to 2 decimals
                              const dueAmount = (
                                ((item.grand_total || 0) + (item.adjusted_total || 0)) - totalPaid
                              ).toFixed(2);

                              const grandTotal =   ((item.grand_total || 0) + (item.adjusted_total || 0)).toFixed(2);
 
                              return (
                                <tr
                                key={item.id}
                                style={{
                                  backgroundColor: item.is_same_day === 1 ? "#ffcccc" : "transparent", // Light red background
                                  color: item.is_same_day === 1 ? "black" : "black" // Ensure text is visible
                                }}
                              >
                              
                                   <td style={{ verticalAlign: 'middle'}}>{item.booking_ref_id}</td>
                                    <td style={{ verticalAlign: 'middle'}}>{item.firstname} {item.lastname}</td>
                                    <td style={{ verticalAlign: 'middle', whiteSpace: 'nowrap'}}>{moment(item.booked_date).format('DD-MMM-YY')}</td>
                                    <td style={{ verticalAlign: 'middle', whiteSpace: 'nowrap' }}>{formatBookedTime(item.booked_time)}</td>
                                    <td style={{ verticalAlign: 'middle', whiteSpace: 'nowrap'}}>
                                    {item.game_type_name || (item.package_name === 'Corporate' 
                                    ? `${item.package_name} - ${item.corporate_package_name}`
                                   : `${item.package_name} - ${item.game_package_name}`
                                    )} </td>
                                  <td style={{ verticalAlign: 'middle'}}>{item.no_of_adults}</td>
                                    <td style={{ verticalAlign: 'middle'}}>{item.no_of_children}</td>
                                     
                                    <td style={{ verticalAlign: 'middle'}}>{grandTotal}</td>
                                    <td style={{ verticalAlign: 'middle'}}>{formattedTotalPaid}</td>
                                    <td style={{ verticalAlign: 'middle'}}>{dueAmount}</td>
                                    <td style={{ verticalAlign: 'middle'}}>{item.location_name}</td>
                                    <td style={{ verticalAlign: 'middle'}}>{item.staff_names ?? 'N/A'}</td>

                                    {/* <td style={{ verticalAlign: 'middle'}}>{item.game_name}</td> */}
                                    <td style={{ verticalAlign: 'middle', whiteSpace: 'nowrap' }}>
  {item.first_name || item.last_name 
    ? `${item.first_name || ''} ${item.last_name || ''}`.trim() 
    : 'Online'}
</td>
{/* <td style={{ verticalAlign: 'middle'}}>{item.status}</td> */}
                                    <td style={{ verticalAlign: 'middle'}}>{moment(item.created_at).format('DD-MMM-YY, h:mm A')}</td>
                                    <td >
                                        <div class="d-flex justify-content-md-end" style={{margin:"7px 0px 0px 0px" }}>
                                        {/* <button class="btn btn-sm btn_secondary"  onClick={() => handleViewBookings(item.id)} style={{ background: "orange", color: "white", margin: "0px 10px 0px 0px"}} >
                                        <i class="bi bi-eye"></i></button> */}
                                   
                                              {/* View Button - Opens in New Tab */}
    <a href={`/booking-details/${item.id}`} target="_blank" rel="noopener noreferrer" class="btn btn-sm btn_secondary" 
       style={{ background: "orange", color: "white"}}>
      <i class="bi bi-eye"></i>
    </a>
                                            <button class="btn btn-sm btn_secondary" data-bs-target="#createNewCustomre" style={{ background: "red", margin: "0px 0px 0px 10px" }}
                                     onClick={(e) => cancelBooking(e, item.id)}><i class="bi-x-circle"></i></button>
                               </div>
                                    </td>
                                </tr> 
                             
)}))}
                            </tbody>
                            <tfoot style={{ borderTop: "1px solid #dee2e6", height: "1px" }}>
    <tr>
        <td colSpan="15" style={{ padding: 0, margin: 0, height: "1px" }}></td>
    </tr>


</tfoot>
                            {/* <tfoot>
                                <tr>
                                <th>Booking Id</th>
                                <th>Customer Name</th>
                                
                                    <th>Location</th>
                                    <th>Game</th>
                                    <th>Booked By</th>
                                    <th>Booked On</th>
                                    <th class="d-flex justify-content-md-end">Action</th>
                                </tr>
                            </tfoot> */}
                        </table>
                        </div>
                        <div class="col-md-3" style={{ float: "left", padding: "20px 0px 0px 0px" }}>
                                        {sortedResult.length > 0 && `Showing 1 to ${Math.min(perPage, filteredResult.length)} of ${filteredResult.length} entries`}
                                    </div>
                                    <div class="col-md-9" style={{ float: "right" }}>

                                        <ReactPaginate style={{ float: "right" }}
                                            previousLabel={"< Prev"}
                                            nextLabel={"Next >"}
                                            breakLabel={'...'}
                                            pageCount={Math.ceil(sortedResult.length / perPage)}
                                            onPageChange={handlePageChange}
                                            containerClassName={"pagination pagination-sm justify-content-center custom-pagination"} // Bootstrap pagination class
                                            disabledClassName={"disabled"}
                                            breakClassName={['page-item']}
                                            breakLinkClassName={'page-link'}
                                            pageClassName={'page-item'}
                                            pageLinkClassName={'page-link'}
                                            previousClassName={'page-item'}
                                            previousLinkClassName={'page-link'}
                                            nextClassName={'page-item'}
                                            nextLinkClassName={'page-link'}
                                            activeClassName={['active']} />


                                    </div>
                    </div>
                </div>
            </div>
        </div>
        </div>
        </div>   
    );
}
export default Bookings;
